import requests from '@/utils/requests';

/**
 * 添加故障接口
 * @param {*} data
 */
export function faultAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/add',
    method: 'post',
    data
  });
}

/**
 * 修改故障接口
 * @param {*} data
 */
export function faultModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/modify',
    method: 'post',
    data
  });
}

/**
 * 删除故障接口
 * @param {*} data
 */
export function faultDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/delete',
    method: 'post',
    data
  });
}

/**
 * 故障列表接口
 * @param {*} data
 */
export function faultList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/list',
    method: 'post',
    data
  });
}

/**
 * 修改故障接口
 * @param {*} data
 */
export function faultDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/detail',
    method: 'post',
    data
  });
}

/**
 * 故障任务列表接口
 * @param {*} data
 */
export function faultTaskList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/task/query',
    method: 'post',
    data
  });
}

/**
 * 添加故障任务接口
 * @param {*} data
 */
export function faultTaskAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/task/add',
    method: 'post',
    data
  });
}

/**
 * 修改故障任务接口
 * @param {*} data
 */
export function faultTaskModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/task/modify',
    method: 'post',
    data
  });
}

/**
 * 删除故障任务接口
 * @param {*} data
 */
export function faultTaskDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/event/fault/task/delete',
    method: 'post',
    data
  });
}
